/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPlaceIdFromAddressResponse
 */
export interface GetPlaceIdFromAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPlaceIdFromAddressResponse
     */
    placeId: string;
}

/**
 * Check if a given object implements the GetPlaceIdFromAddressResponse interface.
 */
export function instanceOfGetPlaceIdFromAddressResponse(value: object): value is GetPlaceIdFromAddressResponse {
    if (!('placeId' in value) || value['placeId'] === undefined) return false;
    return true;
}

export function GetPlaceIdFromAddressResponseFromJSON(json: any): GetPlaceIdFromAddressResponse {
    return GetPlaceIdFromAddressResponseFromJSONTyped(json, false);
}

export function GetPlaceIdFromAddressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlaceIdFromAddressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'placeId': json['placeId'],
    };
}

export function GetPlaceIdFromAddressResponseToJSON(json: any): GetPlaceIdFromAddressResponse {
    return GetPlaceIdFromAddressResponseToJSONTyped(json, false);
}

export function GetPlaceIdFromAddressResponseToJSONTyped(value?: GetPlaceIdFromAddressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'placeId': value['placeId'],
    };
}

